module.exports = __webpack_public_path__ + "static/personas-1-30c47ef58aefb8a4d50c5396a63cb944.svg";